import '../../../../assets/react-datepicker.css'
import { FilterItemProps } from './_common'
import { TextFilter } from './TextFilter/TextFilter'
import { SelectFilter } from './SelectFilter/SelectFilter'
import { DateRangeFilter } from './DateRangeFilter/DateRangeFilter'
import { MultiSelectFilter } from './MultiselectFilter/MultiselectFilter'
import { MetricFilter } from './MetricFilter/MetricFilter'
import { CheckBoxFilter } from './CheckBoxFilter/CheckBoxFilter'
import { GroupingMultiselectFilter } from './GroupingMultiselectFilter/GroupingMultiselectFilter'

interface FilterBarProps {
  children: React.ReactNode
}
export function FilterBar({ children }: FilterBarProps) {
  return (
    <div className="bg-offWhite sticky left-0 top-0 z-10 w-full px-8 py-4 shadow">
      <div className="flex items-start gap-4">{children}</div>
    </div>
  )
}

interface FilterItemWrapperProps {
  children: React.ReactNode
}
FilterBar.FilterItemWrapper = function FilterItemWrapper({
  children,
}: FilterItemWrapperProps) {
  return <div className="space-y-2">{children}</div>
}


interface FilterItemLabelProps {
  children: string
}
FilterBar.ItemLabel = function FilterItemLabel({
  children,
}: FilterItemLabelProps) {
  return <h3 className="truncate text-sm">{children}</h3>
}

FilterBar.TextFilter = TextFilter

FilterBar.SelectFilter = SelectFilter

FilterBar.MultiSelectFilter = MultiSelectFilter

FilterBar.DateRangeFilter = DateRangeFilter

FilterBar.MetricFilter = MetricFilter

FilterBar.CheckBoxFilter = CheckBoxFilter

FilterBar.GroupingMultiselectFilter = GroupingMultiselectFilter